module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_pc_over3000-034f8dfef5c727bf91c5edf021662fa0.png";